import React, { useState, useEffect } from "react";
import "./account-details.scss";
import AddressImg from "../../assets/accounts/address.svg";
import CommImg from "../../assets/accounts/comm.svg";
import ContactImg from "../../assets/accounts/contact.svg";
import InfoImg from "../../assets/accounts/info.svg";
import KycImg from "../../assets/accounts/kyc.svg";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import useAccounts from "../../controller/accounts-controller";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import {
  formateDate,
  getNameFirstLetter,
  numberFormat,
} from "../../utils/helper";
import { useNavigate, useParams } from "react-router-dom";
import ContactSvgHeader from "../../assets/sidebar/dealerPortal/ContactSvgHeader";
import { useDialogContext } from "../../components/dialogs/Dialog";
import { useBottomSheetContext } from "../../components/dialogs/bottomsheet";
import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import { getCookie } from "../../utils/session";

const options = [
  {
    label: "Pending Order Email",
    value: "Item wise Pending Order Details",
  },
  {
    label: "Due/Overdue Invoice Email",
    value: "Due/Overdue Invoice Details",
  },
  {
    label: "Upcoming Invoice Email",
    value: "Upcoming Invoice Details",
  },
];

const AccountDetails = () => {
  const fsoId = getCookie("fsoId");
  const params = useParams();
  const navigate = useNavigate();
  const { dispatch } = useDialogContext();
  const { dispatch: dis } = useBottomSheetContext();
  const {
    getAccDetails,
    sendAccEmail,
    accData,
    mailData,
    isLoading,
    isLoading2,
    succMsg,
    errMsg,
  } = useAccounts();
  const [isLoader, setIsLoader] = useState(false);
  const [isLoader2, setIsLoader2] = useState(false);
  const [accInfo, setAccInfo] = useState({});
  const [openAcc, setOpenAcc] = useState(["0", "1", "2", "3", "4"]);
  const [data, setData] = useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Owner Name",
        accessor: "ownerName",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Email",
        accessor: "email",
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns,
        data,
      },
      useFilters,
      useGlobalFilter,
      useSortBy
    );

  useEffect(() => {
    getAccDetails(params?.aid);
  }, []);

  useEffect(() => {
    setAccInfo(accData);
    setData(accData?.contactList || []);
  }, [accData]);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    setIsLoader2(isLoading2);
  }, [isLoading2]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  useEffect(() => {
    if (succMsg) {
      toast.success(succMsg);
    }
  }, [succMsg]);

  useEffect(() => {
    if (Object.keys(mailData).length > 0) {
      if (window.innerWidth < 960) {
        dis({
          type: "openBottomSheet",
          payload: {
            data: {
              handleEmailClick,
              mailData,
              footer: false,
              cancelBtn: true,
              title: "Email Preview",
              onSubmit: true,
              className: "pb-0 !p-0 md:w-[80vw]",
            },
            path: `MailPreview`,
          },
        });
      } else {
        dispatch({
          type: "openDialog",
          payload: {
            data: {
              modalType: "accountEmail",
              handleEmailClick,
              mailData,
              footer: false,
              cancelBtn: true,
              title: "Email Preview",
              onSubmit: true,
              className: "pb-0 !p-0 relative",
            },
            path: `MailPreview`,
          },
        });
      }
    }
  }, [mailData]);

  const handleEmailClick = (type, isSend = false) => {
    sendAccEmail({
      isSend,
      accountId: params?.aid,
      fsoId,
      emailTemplateName: type,
    });
  };

  return (
    <div
      className={`accounts-container h-full flex flex-col mt-2 md:static overflow-y-auto relative ${
        isLoader ? "mt-2 -mt-[70px]" : ""
      }`}
      id="scroll-div"
    >
      {isLoader ? (
        <div className="flex md:h-full h-[calc(100%_-_100px)] justify-center align-center">
          <Loader />
        </div>
      ) : (
        <>
          <PageHeader
            isBackBtn={true}
            onBackClick={() => (window.location.href = "/account")}
            svg={<ContactSvgHeader color={"white"} />}
            text="Account"
            subTitle={accInfo?.accountName}
            isCreate={true}
            createText={"Create Order"}
            isCreateClasses={"fixed bottom-0 right-0 m-4"}
            onCreateClick={() => {
              if (accInfo?.active) {
                navigate(`/orders/create?accId=${accInfo?.accountId}`);
              } else {
                dispatch({
                  type: "openDialog",
                  payload: {
                    data: {
                      modalType: "changePassword",
                      title: "Inactive Account",
                      className: "pb-0 rounded-lg",
                    },
                    path: `inactive-account/InactiveAccount`,
                  },
                });
              }
            }}
            onMobCreateClick={() => {
              if (accInfo?.active) {
                navigate(`/orders/create?accId=${accInfo?.accountId}`);
              } else {
                dis({
                  type: "openBottomSheet",
                  payload: {
                    data: {
                      modalType: "changePassword",
                      title: "Inactive Account",
                      className: "!pb-0 pt-4 rounded-lg",
                    },
                    path: `inactive-account/InactiveAccount`,
                  },
                });
              }
            }}
            isAccountDetailPage={true}
            handleEmailClick={handleEmailClick}
            options={options}
            isLoading={isLoader2}
          />
          <div>
            <div className="accordianWrapper">
              <Accordion
                allowMultipleExpanded={true}
                allowZeroExpanded={true}
                preExpanded={["0", "1", "2", "3", "4"]}
                onChange={(item) => setOpenAcc(item)}
              >
                <AccordionItem uuid={"0"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("0")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className=" flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={InfoImg} alt="infoImg" className="mr-2" />
                        Basic Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      <div className="grid md:grid-cols-2 md:mb-4">
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                          <div className="fieldName ">Account Name</div>
                          <div className="fieldDetails ">
                            {accInfo?.accountName}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                          <div className="fieldName ">Email</div>
                          <div className="fieldDetails ">{accInfo?.email}</div>
                        </div>
                      </div>
                      <div className="grid md:grid-cols-2 md:mb-4">
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                          <div className="fieldName ">Phone</div>
                          <div className="fieldDetails ">{accInfo?.Phone}</div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                          <div className="fieldName ">Account Owner</div>
                          <div className="fieldDetails font-medium md:text-base text-sm">
                            <div className="flex  flex-row items-center md:justify-start justify-end userData">
                              {/* <img
                                src={accInfo?.accOwnerImg}
                                alt="user"
                                className="rounded-full mr-2"
                              /> */}
                              {accInfo?.ownerName && (
                                <div className="rounded-full bg-black mr-2 flex justify-center items-center">
                                  {getNameFirstLetter(accInfo?.ownerName)}
                                </div>
                              )}
                              {accInfo?.ownerName}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="grid md:grid-cols-2">
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                          <div className="fieldName ">Field Sales Officer</div>
                          <div className="fieldDetails ">
                            {accInfo?.fieldSalesOfficer}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 mb-0 pl-0 px-3">
                          <div className="fieldName ">Commission Agent</div>
                          <div className="fieldDetails ">
                            {accInfo?.agentName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem uuid={"1"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("1")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={KycImg} alt="infoImg" className="mr-2" />
                        KYC Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="accPanel bg-white-100 grid md:rounded-b-lg py-5 px-4">
                      <div className="grid md:grid-cols-2 md:mb-4">
                        <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3 md:mr-10">
                          <div className="text-grey-500 ">GSTIN</div>
                          <div className="fieldDetails ">
                            {accInfo?.gstNo || "NA"}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3">
                          <div className="fieldName ">PAN</div>
                          <div className="fieldDetails ">{accInfo?.panNo}</div>
                        </div>
                      </div>
                      <div className="grid md:grid-cols-2">
                        <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3 md:mr-10">
                          <div className="fieldName ">Aadhar No.</div>
                          <div className="fieldDetails ">
                            {accInfo?.aadharNo}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper mb-0 pb-2 pl-0 px-3">
                          <div className="fieldName ">Birthday</div>
                          <div className="fieldDetails ">
                            {formateDate(accInfo?.birthday)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem uuid={"2"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("2")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={CommImg} alt="infoImg" className="mr-2" />
                        Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      <div className="grid md:grid-cols-2">
                        <div className="grid grid-cols-2 fieldWrapper md:mb-0 mb-4 pb-2 pl-0 px-3 md:mr-10">
                          <div className="fieldName ">
                            Channel Partner Category
                          </div>
                          <div className="fieldDetails ">
                            {accInfo?.channelPartnerCategory}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 fieldWrapper pb-2 pl-0 px-3">
                          <div className="fieldName">Credit Limit</div>
                          <div className="fieldDetails ">
                            {accInfo?.currencyIsoCode}{" "}
                            {numberFormat(accInfo?.sapCreditLimit)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem uuid={"3"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("3")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={AddressImg} alt="infoImg" className="mr-2" />
                        Address Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      <div className="grid md:grid-cols-2">
                        <div className="grid md:grid-cols-2 pl-0 px-3 md:mr-10">
                          <div className="md:mr-10 md:mb-0 mb-4">
                            <div className="fieldName mb-2">
                              Billing Address :
                            </div>
                            <div className="fieldDetails font-medium md:text-base text-sm">
                              <div className="flex flex-row rounded-lg p-4 addressData">
                                {accInfo?.billingStreet},<br />
                                {accInfo?.billingCity},{" "}
                                {accInfo?.billingPostalCode}
                                ,
                                <br />
                                {accInfo?.billingState},<br />
                                {accInfo?.billingCountry}
                              </div>
                            </div>
                          </div>
                          <div className="md:mr-10 md:mb-0">
                            <div className="fieldName mb-2">
                              Shipping Address :
                            </div>
                            <div className="fieldDetails font-medium md:text-base text-sm">
                              <div className="flex flex-row rounded-lg p-4 addressData">
                                {accInfo?.shippingStreet},<br />
                                {accInfo?.shippingCity},{" "}
                                {accInfo?.shippingPostalCode}
                                ,<br />
                                {accInfo?.shippingState},<br />
                                {accInfo?.shippingCountry}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem uuid={"4"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("4")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={ContactImg} alt="infoImg" className="mr-2" />
                        Contact Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      {accInfo?.contactList?.length > 0 ? (
                        <div className="table-container card overflow-auto w-full">
                          <div className="overflow-auto w-full order-list-table shadow-sm rounded-md bg-white-100 h-auto">
                            <table {...getTableProps()} className="w-full">
                              <thead>
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    {...headerGroup.getHeaderGroupProps()}
                                    key={i}
                                  >
                                    {headerGroup.headers.map((column, i) => (
                                      <th
                                        {...column.getHeaderProps(
                                          column?.id !== "action" &&
                                            column.getSortByToggleProps()
                                        )}
                                        className={`md:text-lg text-base md:min-w-fit min-w-[180px] p-3 font-bold md:text-lg text-base ${
                                          column.isSorted
                                            ? "flex flex-row justify-between items-center"
                                            : ""
                                        } p-3.5	${
                                          i === 0
                                            ? "md:rounded-tl-lg min-w-[100px] left-0 z-[3]"
                                            : ""
                                        } ${
                                          i === headerGroup.headers.length - 1
                                            ? "md:rounded-tr-lg"
                                            : ""
                                        }`}
                                      >
                                        {column.render("Header")}
                                        <span>
                                          {column.isSorted ? (
                                            column.isSortedDesc ? (
                                              <div className="accIconClose inline-block mr-3 rotate-45 ml-2" />
                                            ) : (
                                              <div className="accIconOpen inline-block mr-3 ml-2" />
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>
                              <tbody {...getTableBodyProps()}>
                                {rows.map((row, i) => {
                                  prepareRow(row);
                                  return (
                                    <tr
                                      {...row.getRowProps()}
                                      key={i}
                                      className="cursor-pointer"
                                    >
                                      {row.cells.map((cell, i2) => {
                                        return (
                                          <td
                                            {...cell.getCellProps()}
                                            className={`p-3 md:text-base text-sm ${
                                              i2 === 0
                                                ? "sticky left-0 z-[2]"
                                                : ""
                                            }`}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                })}
                                {rows?.length < 1 ? (
                                  <p className="mt-2 font-medium text-sm no-table-record">
                                    No Record Found
                                  </p>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AccountDetails;
